import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

export async function getMappedPosition(locationId: string, systemPosition: string) {
	const query = gql`
		query getMappedPosition($locationId: String!, $systemPosition: String!) {
			getMappedPosition(locationId: $locationId, systemPosition: $systemPosition) {
				_id
				systemPosition
				isDepartmental
			}
		}
	`;

	const variables = {
		locationId,
		systemPosition,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getMappedPosition || null;
	} catch (err) {
		errorLogger(err as Error, { function: "getMappedPosition", message: "Error getting mapped position", variables });
		return null;
	}
}

export async function retrievePositionsMap(locationId: string) {
	const query = gql`
		query getMappedPositions($locationId: String!) {
			getMappedPositions(locationId: $locationId) {
				_id
				systemPosition
				payrollPosition
				drawFrequency
				isDepartmental
				chargebackDeductionCodes {
					code
					deductionType
				}
				ptoType {
					value
					modality
					modalityDefinition {
						frequency
						input
						value
						excludeHolidays
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getMappedPositions;
	} catch (err) {
		errorLogger(err as Error, {
			function: "retrievePositionsMap",
			message: "Error getting required mapped positions",
			variables,
		});
		return null;
	}
}
